var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgThickFogCross = function SvgThickFogCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    stroke: "#848484",
    d: "m18.191 4.292.354-.353-.354-.354-1.611-1.611-.353-.354-.354.354-6.035 6.035-6.035-6.035-.354-.354-.353.354-1.612 1.611-.353.354.353.353 6.035 6.035-6.035 6.035-.353.354.353.353 1.612 1.612.353.353.354-.353 6.035-6.035 6.035 6.035.354.353.353-.353 1.611-1.612.354-.353-.354-.354-6.035-6.035z"
  })));
};
export { SvgThickFogCross as ReactComponent };
export default __webpack_public_path__ + "images/thick_fog_cross.svg";